export const EmailTypes = {
    SHARE_ACCESS: 30,
    SHARE_PAYMENT_LINK: 35
};
